import { render, staticRenderFns } from "./statistics-block.vue?vue&type=template&id=490e3b7c&scoped=true&"
import script from "./statistics-block.vue?vue&type=script&lang=js&"
export * from "./statistics-block.vue?vue&type=script&lang=js&"
import style0 from "./statistics-block.vue?vue&type=style&index=0&id=490e3b7c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490e3b7c",
  null
  
)

export default component.exports